import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState } from 'preact/hooks';
import { getInitials, getCompanyInitials } from '@/utils/initials';
const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-xs',
    lg: 'w-10 h-10 text-sm',
    xl: 'w-16 h-16 text-base'
};
/**
 * Avatar component for displaying a person's profile picture or initials.
 * Handles image load errors by falling back to initials.
 */
export const PersonAvatar = ({ firstName, lastName, fullName, profilePicUrl, alt, size = 'md' }) => {
    const [imageStatus, setImageStatus] = useState(profilePicUrl ? 'loading' : 'error');
    const initials = getInitials({ firstName, lastName, fullName });
    const displayName = alt || fullName || [firstName, lastName].filter(Boolean).join(' ') || 'User';
    const sizeClass = sizeClasses[size];
    const handleImageLoad = () => {
        setImageStatus('loaded');
    };
    const handleImageError = () => {
        setImageStatus('error');
    };
    return (_jsxs("div", { class: `${sizeClass} rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden flex items-center justify-center font-semibold text-gray-600 dark:text-gray-300 relative`, title: displayName, children: [(!profilePicUrl || imageStatus === 'error') && (_jsx("span", { children: initials })), profilePicUrl && (_jsx("img", { src: profilePicUrl, alt: displayName, class: "w-full h-full object-cover absolute inset-0", loading: "lazy", referrerPolicy: "no-referrer", onLoad: handleImageLoad, onError: handleImageError, style: { opacity: imageStatus === 'loaded' ? 1 : 0 } }))] }));
};
/**
 * Avatar component for displaying a company logo or initials.
 * Handles image load errors by falling back to initials.
 */
export const CompanyAvatar = ({ companyName, logoUrl, alt, size = 'md' }) => {
    const [imageStatus, setImageStatus] = useState(logoUrl ? 'loading' : 'error');
    const initials = getCompanyInitials(companyName);
    const displayName = alt || companyName;
    const sizeClass = sizeClasses[size];
    const handleImageLoad = () => {
        setImageStatus('loaded');
    };
    const handleImageError = () => {
        setImageStatus('error');
    };
    return (_jsxs("div", { class: `${sizeClass} rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden flex items-center justify-center font-semibold text-gray-600 dark:text-gray-300 relative`, title: displayName, children: [(!logoUrl || imageStatus === 'error') && (_jsx("span", { children: initials })), logoUrl && (_jsx("img", { src: logoUrl, alt: displayName, class: "w-full h-full object-cover absolute inset-0", loading: "lazy", referrerPolicy: "no-referrer", onLoad: handleImageLoad, onError: handleImageError, style: { opacity: imageStatus === 'loaded' ? 1 : 0 } }))] }));
};
